module.exports = __webpack_public_path__ + "static/media/171IT121.278aee8b.jpg";